import moment from "moment"
export const UpcomingDummy = () => {
  return {
    "data": {
      "upcoming_stays": [
        {
          "dob": null,
          "email": "jm9@on99.com",
          "phone": {
            "phone_number": "+66 812345678",
            "phone_country_code": "66",
            "phone_number_without_code": "812345678"
          },
          "title": null,
          "guests": {
            "adult": 1,
            "child": 0
          },
          "status": "ready_to_pre_checkin",
          "address": {
            "city_name": null,
            "address_type": "HOME",
            "country_of_residence": null,
            "country_of_residence_code": null
          },
          "resv_id": "202335",
          "check_in": moment().toISOString(),
          "passport": {
            "document_number": "123"
          },
          "check_out":  moment().toISOString(),
          "last_name": "Chan",
          "room_code": "PQ",
          "booking_id": "45826784-1",
          "first_name": "Peter",
          "profile_id": 2568,
          "nationality": "Chinese",
          "total_guests": 1,
          "number_of_rooms": 1,
          "additionalGuests": [],
          "nationality_code": "HKG",
          "room_description": "Premier Queen"
        },
        {
          "dob": null,
          "email": "johndoe@on55.com",
          "phone": {
            "phone_number": "+852 222222",
            "phone_country_code": "66",
            "phone_number_without_code": "812345678"
          },
          "title": null,
          "guests": {
            "adult": 1,
            "child": 0
          },
          "status": "ready_to_pre_checkin",
          "address": {
            "city_name": null,
            "address_type": "HOME",
            "country_of_residence": null,
            "country_of_residence_code": null
          },
          "resv_id": "202335",
          "check_in": moment().toISOString(),
          "passport": {
            "document_number": "123"
          },
          "check_out":  moment().toISOString(),
          "last_name": "DOe",
          "room_code": "PQ",
          "booking_id": "5555555-5",
          "first_name": "John",
          "profile_id": 2568,
          "nationality": "Chinese",
          "total_guests": 1,
          "number_of_rooms": 1,
          "additionalGuests": [],
          "nationality_code": "HKG",
          "room_description": "Premier Queen"
        }
      ],
      "pms_interface_type": "infor",
      "error_message": null,
      "status": "finish"
    }
  }
}

